import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck, UserCheck, TrendingUp, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const QUOTES = [
  "Korku, henüz denemediğin şeyin adıdır.",
  "Cesaret korkusuz olmak değil; korkuya rağmen gaza basmaktır.",
  "Herkes bir gün ilk kez gaza bastı.",
  "Konfor alanın bittiği yerde parkur başlar.",
  "İlk tur heyecan verir. İkinci tur gülümsetir.",
  "Korkunu yanına al, gerisini biz hallederiz.",
];

export const QuoteBand = ({ className = "" }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % QUOTES.length), 4500);
    return () => clearInterval(t);
  }, []);
  return (
    <section data-testid="quote-band" className={`relative overflow-hidden border-y border-white/10 bg-black ${className}`}>
      <div className="mx-auto flex min-h-[260px] max-w-7xl items-center px-5 py-16 md:min-h-[320px] md:px-8">
        <span aria-hidden className="mr-6 hidden font-display text-[10rem] leading-none text-brand md:block">“</span>
        <AnimatePresence mode="wait">
          <motion.p key={i} data-testid="quote-text" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }} transition={{ duration: 0.6 }} className="font-display text-4xl uppercase leading-[0.95] text-white md:text-7xl">
            {QUOTES[i]}
          </motion.p>
        </AnimatePresence>
      </div>
    </section>
  );
};

const POINTS = [
  { icon: ShieldCheck, t: "Ekipman bizden", d: "Kask, gözlük, koruyucular, bot ve eldivenle tepeden tırnağa korunarak sürersin." },
  { icon: UserCheck, t: "Yalnız değilsin", d: "Profesyonel rehber ve eğitmenlerimiz parkurda hep yanında." },
  { icon: TrendingUp, t: "Adım adım", d: "Seviyene göre başlar, kendini hazır hissettikçe ilerlersin. Acele yok." },
];

export const FearSection = () => (
  <section data-testid="fear-section" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
    <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1.1fr] lg:items-end">
      <Reveal>
        <Eyebrow>Korkuyor musun?</Eyebrow>
        <h2 className="font-display text-5xl uppercase leading-[0.9] text-white md:text-7xl">Korkmak normal. <span className="text-brand">Hazırlıksız sürmek değil.</span></h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="text-base leading-relaxed text-neutral-400 md:text-lg">Enduroya başlayan herkes ilk gün aynı şeyi hisseder. Fark yaratan; doğru ekipman, deneyimli bir rehber ve kendi hızında ilerlemektir. Biz bu üçünü sana sunuyoruz.</p>
        <Link to="/egitimlerimiz" data-testid="fear-cta-btn" className="group mt-8 inline-flex items-center gap-3 bg-brand px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-brand">
          İlk adımı at <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
    <div className="mt-16 grid grid-cols-1 border-l border-t border-white/10 md:grid-cols-3">
      {POINTS.map((p, i) => (
        <Reveal key={p.t} delay={i * 0.08} className="border-b border-r border-white/10 p-8">
          <div data-testid={`fear-point-${i}`}>
            <p.icon className="h-10 w-10 text-brand" strokeWidth={1.5} />
            <h3 className="mt-6 font-display text-3xl uppercase text-white">{p.t}</h3>
            <p className="mt-3 leading-relaxed text-neutral-400">{p.d}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
